// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#unreadChatMessages .counter[data-v-b430bb12]{font-size:.8rem;position:absolute;top:2px;left:10px;padding:3px}.chat-icon[data-v-b430bb12]{border-radius:50%}.chat-icon.animate[data-v-b430bb12]{transition:.3s;animation:hoverBlueWave 1.5s linear infinite}", ""]);
// Exports
module.exports = exports;
